import { Component, HostListener, Inject, NgZone, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { Router, Event, NavigationStart, NavigationEnd } from '@angular/router';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.css'],
    standalone: false
})
export class AppComponent {
  title = 'office-new-website';
  active:any = '/'
  loading : boolean = true;

  constructor (
    private  route : Router,
    private zone: NgZone,
    @Inject(PLATFORM_ID) private platformId: Object
  ){
    this.route.events.subscribe( ( routerEvent : Event ) => {
      if( routerEvent instanceof NavigationStart )
      {
        this.loading = true
      }
      if( routerEvent instanceof NavigationEnd )
      {
        this.loading = false
        this.refreshScrollTriggers()
      }
    })
  }

  /**
   * On a client-side navigation each new section builds its ScrollTriggers
   * while the outgoing page is still occupying the document, so every trigger
   * caches a start position that no longer exists once the swap completes —
   * they then never fire and the section stays at its entrance opacity. A
   * refresh once the new view has laid out re-measures them all.
   *
   * Two frames: one for Angular to render the new view, one for layout.
   */
  private refreshScrollTriggers(): void {
    if (!isPlatformBrowser(this.platformId)) return;
    this.zone.runOutsideAngular(() =>
      requestAnimationFrame(() =>
        requestAnimationFrame(() => ScrollTrigger.refresh())
      )
    );
  }


  isShow?: boolean;
  topPosToStartShowing = 100;

  @HostListener('window:scroll')
  checkScroll() {

    const scrollPosition = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;

    if (scrollPosition >= this.topPosToStartShowing) {
      this.isShow = true;
    } else {
      this.isShow = false;
    }
  }

  checkHomeRoute(url:any) {
    console.log(url);
    this.active = url
  }

  // TODO: Cross browsing
  gotoTop() {
    window.scroll({
      top: 0,
      left: 0,
      behavior: 'smooth'
    });
  }
}
